import "../libs/spinner";
import {isArray} from "util";
import ready from "../libs/docready";

const formActions = {};
export default formActions;

const showSection = function ($input) {
    if ($input.is(':visible')) {
        return;
    }
    $input.closest('section[data-tab]').trigger('select')
}

formActions.loadForm = async function(url, query) {
    window.spinner.show();
    window.ariaRead(window.translate.app_window_loading_message);
    try {
        const content = await $.get(url, query)
        let html
        if (content.modal) {
            if (Array.isArray(content.modal)) {
                // @todo create simpleModal or bootstrap modal according to config.
            } else {
                html = content.modal.replace('%content%', content.body);
            }
        } else {
            html = content.body
        }
        const modal = $(html)
        // Before any event is triggered, we register global vars.
        if (content.vars) {
            Object.entries(content.vars).forEach(function ([name, value]) {
                window[name] = value
            })
        }
        modal.prependTo($('#bootstrapWidgetsContainer'))
        modal.on('hidden.bs.modal', () => modal.remove())
        ready(modal)
        spinner.remove();
        return modal;
    } catch (e) {
        spinner.remove()
        throw e
    }
}

/**
 *
 * @param form the jquery form
 * @param errors errors to apply {"key": "error message"}
 * @param fieldPattern search query to find the input: {field} wil be replaced by error key
 * @param containerPattern search query of surrounding container where the error tag will be attached
 * @param messageBuilder callable for creating a custom error message element
 * @returns {Promise<Awaited<unknown>[]>}
 */
formActions.applyFormErrors = async function(form, errors, fieldPattern="#{field}", containerPattern=".form-group", messageBuilder = null) {
    let promises = [];
    let showField = true;
    Object.entries(errors).forEach(function ([field, message]) {
        promises.push(new Promise(resolve => {

            message = isArray(message) ? message[0] : message;
            let $field = typeof fieldPattern === 'function'
                ? fieldPattern(field)
                : form.find(fieldPattern.replace('{field}', field));
            if (showField) {
                showSection($field)
                showField = false
            }
            const $container = typeof containerPattern === 'function'
                ? containerPattern(field, $field)
                : $field.closest(containerPattern);
            $container.addClass('has-error');
            if (typeof messageBuilder === 'function') {
                messageBuilder(field, $field, $container, message);
            } else {
                let $errorp = $('<p>').attr('id', field + '-error').addClass('help-block').addClass('help-block-error').text(message);
                $container.append($errorp);
                $field.attr('aria-describedby',field+'-error');
            }
            $field.attr('aria-invalid', 'true');

            // phone cc:
            const phoneCC = form.find(fieldPattern.replace('{field}', field + '_cc'));
            if(phoneCC.length) {
                phoneCC.attr('aria-invalid', 'true')
                phoneCC.attr('aria-describedby',field+'-error');
            }

            // wysiwyg:
            const contentEditor = form.find(fieldPattern.replace('{field}', field + '_trumbowyg-editor'));
            if(contentEditor.length) {
                contentEditor.attr('aria-invalid', 'true')
                contentEditor.attr('aria-describedby',field+'-error');
            }
            resolve()
        }))
    })
    return Promise.all(promises);
};

formActions.cleanForm = form => {
    form.find('.has-error').removeClass('has-error');
    form.find('.has-success').removeClass('has-success');
    form.find('.help-block-error').remove();
    form.find('[aria-invalid]').removeAttr('aria-invalid');
    form.find('.error-in-tooltip').each(function() {
        if ($(this).attr('data-tooltip')) {
            $(this).data($(this).attr('data-tooltip'))
        } else {
            $(this).unsetTooltip()
        }
    });
}
